declare const SOFTLINE_BUILD_VERSION: string | undefined;

export function dateVersion(date: Date = new Date()): string {
  return [date.getFullYear() % 100, date.getMonth() + 1, date.getDate()].join('.');
}

/** Set once per build by tools/build-version; the runtime date only covers unbundled code such as unit tests. */
export const version =
  typeof SOFTLINE_BUILD_VERSION === 'string'
    ? SOFTLINE_BUILD_VERSION
    : `${dateVersion()}-local`;
